import { ReactElement, useMemo } from 'react';
import { Navigate } from 'react-router-dom';

import useAuth from 'hooks/useAuth';
import Loader from 'components/Loader';
import { getModuleAccess, parsePermissionsFromUser } from 'utils/permissionsFromUser';

type Props = {
  /** API permission `module` value (e.g. `users`, `roles`, `notification`). */
  module: string;
  children: ReactElement;
};

export default function ModuleRoute({ module, children }: Readonly<Props>) {
  const { user, isInitialized } = useAuth();
  const canRead = useMemo(() => getModuleAccess(parsePermissionsFromUser(user), module).read, [user, module]);

  if (isInitialized !== true) {
    return <Loader />;
  }

  if (!canRead) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
